/** English copy interpolation only; escape the result when inserting into HTML. */
export function formatCopy(message: string, values: Readonly<Record<string, string | number>>): string {
  return message.replace(/\{\{([A-Za-z][A-Za-z0-9_]*)\}\}/g, (placeholder, key: string) =>
    Object.hasOwn(values, key) ? String(values[key]) : placeholder);
}
